import { Grid, Typography } from "@mui/material";
import { StyledComponentProps } from "@mui/styles";
import { FeedClassKey } from "assets/jss/common-styles";
import ButtonCardAction from "components/Buttons/ButtonCardAction";
import ButtonFollow from "components/Buttons/ButtonFollow";
import IconEditSquare from "components/Icons/IconEditSquare";
import IconFollowers from "components/Icons/IconFollowers";
import IconKnowsAbout from "components/Icons/IconKnowsAbout";
import MuiClickable from "components/MuiExtras/MuiClickable";
import MuiImage from "components/MuiExtras/MuiImage";
import MuiPaper from "components/MuiExtras/MuiPaper";
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import HtmlUtils from "lib/HtmlUtils";
import { SystemRoles } from "models/ApiEnums";
import { TopicUserFlowListItemDto } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router";
import { RoutePaths } from "routes/RouteConfig";
import Session from "services/Session";
import { PublicationAdminListParameters } from "views/Publication/PublicationAdminList";
import TopicFollowersDrawer from "views/Topic/Dialogs/TopicFollowersDrawer";
import TopicWhoKnowsAboutDrawer from "views/Topic/Dialogs/TopicWhoKnowsAboutDrawer";
import MuiLink from "components/MuiExtras/MuiLink";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    dialog: any;
}

interface IProps {
    topic: TopicUserFlowListItemDto;
    onFollow?: () => void;
    onViewFeed?: () => void;
}

type Props = IProps & WithTranslation & WithSnackbar & StyledComponentProps<FeedClassKey> & RouteComponentProps;

/////////////////////////////////////////////////////////////////////////////////////

class TopicCardFollow extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            dialog: null,
        };
    }

    ///
    private handleFollower = () => {
        this.setState({
            dialog: <TopicFollowersDrawer
                topicId={this.props.topic.topicId}
                onClose={() => { this.setState({ dialog: null }); }}
            />
        });
    };

    ///
    private handleWhoKnowsAbout = () => {
        this.setState({
            dialog: <TopicWhoKnowsAboutDrawer
                topicId={this.props.topic.topicId}
                onClose={() => { this.setState({ dialog: null }); }}
            />
        });
    };

    ///
    private handlePublications = () => {
        const { topicId, name, thumbnailUrl } = this.props.topic;

        if (Session.hasRole(SystemRoles.Administrator)) {
            this.props.history.push(RoutePaths.PublicationAdminList, {
                topic:
                {
                    key: topicId,
                    label: name,
                    thumbnailUrl: thumbnailUrl,
                    canDelete: true,
                }
            } as PublicationAdminListParameters);
        }
        else {
            HtmlUtils.openUrlInNewWindow(RoutePaths.TopicViewer.replace(":id", topicId));
        }
    };

    ///
    public render() {
        const {
            classes,
            topic
        } = this.props;

        const topicName = <Typography variant="h6">{topic.name}</Typography>;

        const thumbnail = <MuiImage size="sm" orientation="square" src={topic.thumbnailUrl} />;

        return (
            <>
                <MuiPaper className={classes.card}>

                    <Grid container spacing={2} >
                        <Grid item>
                            {
                                this.props.onViewFeed
                                    ? <MuiClickable onClick={this.props.onViewFeed}>{thumbnail}</MuiClickable>
                                    : thumbnail
                            }

                        </Grid>
                        <Grid item xs>

                            <Grid container justifyContent="space-between" alignItems="flex-start" wrap="nowrap" >
                                <Grid item className={classes.titleContainer}>
                                    {
                                        this.props.onViewFeed
                                            ? <MuiLink onClick={this.props.onViewFeed}>{topicName}</MuiLink>
                                            : topicName
                                    }
                                </Grid>
                            </Grid>

                            <Grid container
                                justifyContent="space-between"
                                alignItems="center"
                                className={this.props.classes.cardActions}
                            >

                                <Grid item>
                                    <Grid container alignItems="center">
                                        <Grid item>
                                            <ButtonCardAction
                                                title={this.props.t("Common.Feed.Actions.ButtonPublicationsTitle")}
                                                onClick={this.handlePublications}
                                                startIcon={<IconEditSquare />}
                                            >
                                                <span>{topic.publications}</span>
                                            </ButtonCardAction>

                                            <ButtonCardAction
                                                title={this.props.t("Common.Feed.Actions.ButtonFollowersTitle")}
                                                onClick={this.handleFollower}
                                                startIcon={<IconFollowers />}
                                            >
                                                <span>{topic.followers}</span>
                                            </ButtonCardAction>

                                            <ButtonCardAction
                                                title={this.props.t("Common.Feed.Actions.ButtonPeopleKnowsTopicTitle")}
                                                onClick={this.handleWhoKnowsAbout}
                                                startIcon={<IconKnowsAbout />}
                                            >
                                                <span>{topic.whoKnowsAbout}</span>
                                            </ButtonCardAction>


                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item>
                                    <Grid container alignItems="center">

                                        {
                                            this.props.onFollow &&
                                            <Grid item>
                                                <ButtonFollow
                                                    fullWidth
                                                    width="large"
                                                    following={topic.following}
                                                    followColor={"success"}
                                                    unfollowColor={"warning"}
                                                    onClick={this.props.onFollow}
                                                />
                                            </Grid>
                                        }

                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>

                </MuiPaper>


                {this.state.dialog}
            </>
        );
    }
}

export default withRouter(withSnackbar(withTranslation()(TopicCardFollow)));